import React, {useEffect, useState} from "react";
import { Link } from "react-router-dom";
import {CategoryCollapse} from "./TemplatesMenu";

function TemplateCategory(props) {
    const {templateCategory, filterTemplatesByCategory, categoriesCollapse, isMobile, selectedTemplateIdx} = props;
    const {categoryName, templatesList} = templateCategory;

    const [isExpanded, setIsExpanded] = useState(false);

    useEffect(() => {
        if (selectedTemplateIdx > -1) {
            setIsExpanded(true);
        }
        if (isMobile) {
            if (categoriesCollapse == CategoryCollapse.EXPANDED) {
                setIsExpanded(true);
            } else if (categoriesCollapse == CategoryCollapse.COLLAPSED) {
                setIsExpanded(false);
            }
        }
    }, [categoriesCollapse, selectedTemplateIdx]);


    const domTemplates = templatesList ? templatesList.map((template, idx) => (
        <li key={template.questId} className={"list__item" + (idx == selectedTemplateIdx ? " highlighted" : "")}>
            <Link to={{pathname: "/survey-templates/" + template.questId, state: {questId:template.questId}}}>
                {isMobile && <img alt={template.questTitle} src={template.mediaId ? '/rest/quests/getMedia/' + template.mediaId : ''} />}
                <div className="template__card__title">{template.questTitle}</div>
            </Link>
        </li>
    )) : [];

    const onCategoryClick = (e) => {
        e.preventDefault();
        setIsExpanded(!isExpanded);
        !isMobile && filterTemplatesByCategory(categoryName);
    }

    return (
        <li className={"list__item list__item--collapsible" + (isExpanded ? " list__item--open" : "")}>
            <div className="list__item__title" onClick={onCategoryClick}>{categoryName}</div>
            <ul className="list ">
                {domTemplates}
            </ul>
        </li>
    );
}

export default TemplateCategory;